import Mock from 'mockjs'

const domain = '/api/';

//模拟login接口

Mock.mock(domain + 'login',function(){
    let result = {
        code:200,
        message:'OK',
        data:{
            loginUid:1000,
            nickname:'测试mock',
            token:'yyds2022'
        }
    }
    return result
})

//模拟测试接口
Mock.mock(domain + 'test',function(){
    let result = {
        code:200,
        message:'OK',
        data:{
            loginUid:1000,
            nickname:'测试test',
            token:'yyds2022'
        }
    }
    return result
})

//模拟测试获取路由
Mock.mock(domain + 'router',function(){
    let result = {
        code: 200,
        message:'OK',
        data:{
            routers:[
                {
                  id: '1',
                  key: '/',
                  title: '网站首页'
                },
                {
                  title: '公司组织',
                  children: [
                    {
                      id: '2-1',
                      key: '/list/listfirst',
                      title: '杭州总部'
                    },
                    {
                      id: '2-2',
                      key: '/list/listsecond',
                      title: '南京分公司',
                    }
                  ]
                },
                {
                  id: '3',
                  key: '/login',
                  title: '公司业务',
          
                },
                {
                  id: '4',
                  key: '/register',
                  title: '获奖风采',
                },
              ]
        }
    }
    return result
})
